import * as React from "react";
import * as classNames from "classnames";
import { withTheme } from "../../../../../../common/withTheme";
import { Link } from "react-router-dom";
import InternalClassificationLink from "../../../../Common/Links/InternalClassificationLink";
import FileImageThumbnail from "../../../../../File/FileImageThumbnail";

class PageHome extends React.PureComponent<any, any> {
	constructor(props, context) {
		super(props, context);
	}

	render() {
		return (
			<>
				<h2>What is the Australian Platypus Monitoring Network (APMN)?</h2>
				<div className="row">
					<div className="col-md-8 col-12">
						<p>Little or nothing is known about the status and stability of most platypus populations across the animal’s natural range from Queensland south to Tasmania.</p>
						<p>APMN is an innovative Citizen Science approach to monitoring the platypus. Volunteers record platypus sightings at one or more sites using a standard visual survey method. This information is then analysed to see whether platypus activity is trending up or down or remaining steady over time. By tracking population trends, conservation action can be taken sooner rather than later to help ensure this remarkable animal’s survival.</p>
						<p>The Australian Platypus Monitoring Network (APMN) is an initiative of the {InternalClassificationLink("australian-platypus-conservancy", "Australian Platypus Conservancy (APC)", undefined, undefined)}.</p>
					</div>
					<div className="col-md-4 col-12 px-md-3 px-5">
						<div className="border p-2 shadow">
							<Link to="/findings">
								<img
									src={require("../../../../../../assets/img/platypus/content/australia2.jpg")}
									alt="View findings"
									className={classNames(
										this.props.theme,
										"image image-col w-100"
									)}
								/>
							</Link>
							<Link
								to="/findings"
								className={classNames(this.props.theme, "btn btn-primary btn-lg w-100")}
							>View Findings
						</Link>
						</div>
					</div>
				</div>
				<h2>Should I become an APMN volunteer?</h2>
				<p>APMN has been designed to be a very flexible program, catering to anyone who routinely walks, jogs, rides a bicycle or otherwise spends time along a creek, river or lake. It requires only a relatively modest time commitment.</p>
				<p>If you think you might like to become an APMN volunteer, first go to {InternalClassificationLink("join-apmn", "Things to Consider before You Join APMN", undefined, undefined)} and then follow the link to volunteer registration.</p>
				<p>Alternatively, if you simply want to report a platypus sighting, you can record the details online through the <a rel="noopener" target="_blank" href="https://platypus.asn.au/report-a-sighting/">APC website Report a Sighting</a> page.</p>
				<p>If you want to know more about the platypus, you can find lots of information on the <a rel="noopener" target="_blank" href="https://platypus.asn.au">APC website</a>.</p>

				<h2>Supporters</h2>
				<p>Development of the Australian Platypus Monitoring Network website has been made possible through very generous funding provided by Dr Denis and Mrs Vee Saunders. The APC gratefully acknowledges their support for this and other important conservation projects over many years.</p>

				<h2>Project Partners</h2>
				<div className="row d-flex align-items-center text-center">
					<div className="col-md-4 col-6">
						<img
							className="img-fluid"
							src={require("../../../../../../assets/img/platypus/content/partners/GBCMA.png")}
							alt="GBCMA logo"
							title="GBCMA logo"
						/>
					</div>
					<div className="col-md-4 col-6">
						<img
							className="img-fluid"
							src={require("../../../../../../assets/img/platypus/content/partners/FNAC.jpg")}
							alt="FNAC"
							title="FNAC"
						/>
					</div>
					<div className="col-md-4 col-6">
						<a rel="noopener noreferrer" target="_blank" href="https://www.manningham.vic.gov.au/">
							<img
								className="img-fluid"
								src={require("../../../../../../assets/img/platypus/content/partners/Manningham.png")}
								alt="Manningham logo"
								title="Manningham logo"
							/>
						</a>
						<a rel="noopener noreferrer" target="_blank" ref="no" href="https://www.manningham.vic.gov.au/">manningham.vic.gov.au</a>
					</div>
					<div className="col-md-4 col-6">
						<img
							className="img-fluid"
							src={require("../../../../../../assets/img/platypus/content/partners/NECMA.jpg")}
							alt="NECMA Logo"
							title="NECMA Logo"
						/>
					</div>
					<div className="col-md-4 col-6">
						<img
							className="img-fluid"
							src={require("../../../../../../assets/img/platypus/content/partners/AusGEO.jpg")}
							alt="AusGEO Logo"
							title="AusGEO Logo"
						/>
					</div>
					<div className="col-md-4 col-6">
						<img
							className="img-fluid"
							src={require("../../../../../../assets/img/platypus/content/partners/CCMA.jpg")}
							alt="CCMA Logo"
							title="CCMA Logo"
						/>
					</div>
				</div>
			</>
		);
	}
}

export default withTheme<any>(PageHome);
